import React, { useState } from "react";
import "./AcoesFormulario.css";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const AcoesFormulario = ({
  onSalvar,
  onPrePublicar,
  onPublicarFormulario,
  onPreSolicitarCorrecao,
  onSolicitarCorrecao,
  showSolicitarCorrecao,
  showSolicitarAssinatura,
  showSalvar = true,
  skipPreSalvarAssinatura = false,
  isPublishing = false,
  isSolicitandoCorrecao = false,
  TabelaReembolso,
}) => {
  const [showModalAssinatura, setShowModalAssinatura] = useState(false);
  const [emailAprovador, setEmailAprovador] = useState("");
  const [isSalvando, setIsSalvando] = useState(false);
  const [isPreparandoCorrecao, setIsPreparandoCorrecao] = useState(false);
  const [isAbrindoAssinatura, setIsAbrindoAssinatura] = useState(false);
  const [isConfirmandoAssinatura, setIsConfirmandoAssinatura] = useState(false);
  const [emailValido, setEmailValido] = useState(true);
  const validarEmail = (v) => /\S+@\S+\.\S+/.test(String(v || "").trim());

  const temParcelaASolicitar =
    Array.isArray(TabelaReembolso) &&
    TabelaReembolso.some(
      (p) =>
        String(p?.situacao || "")
          .trim()
          .toLowerCase() === "solicitando",
    );

  const exibirSolicitarAssinatura =
    typeof showSolicitarAssinatura === "boolean"
      ? showSolicitarAssinatura
      : temParcelaASolicitar;

  const handleSalvar = async () => {
    if (!onSalvar) return;
    console.groupCollapsed("[Ações] SALVAR :: clique");
    try {
      setIsSalvando(true);
      await onSalvar();
    } catch (e) {
      console.error("[Ações] SALVAR :: erro", e);
    } finally {
      setIsSalvando(false);
      console.groupEnd();
    }
  };

  const handleAbrirAssinatura = async () => {
    console.groupCollapsed("[Ações] PUBLICAR :: clique no botão");
    try {
      setIsAbrindoAssinatura(true);

      if (!skipPreSalvarAssinatura) {
        const ok = await onPrePublicar?.();

        if (!ok) {
          console.warn(
            "[Ações] PUBLICAR :: pré-publicação falhou → não abrir modal",
          );
          return;
        }
      }

      setEmailValido(true);
      setShowModalAssinatura(true);
    } catch (e) {
      console.error("[Ações] PUBLICAR :: erro no onPrePublicar", e);
    } finally {
      setIsAbrindoAssinatura(false);
      console.groupEnd();
    }
  };

  const handleConfirmarAssinatura = async () => {
    console.groupCollapsed("[Ações] PUBLICAR :: confirmação no modal");
    const ok = validarEmail(emailAprovador);
    setEmailValido(ok);
    if (!ok) {
      console.warn("[Ações] PUBLICAR :: e-mail inválido, impedindo envio");
      console.groupEnd();
      return;
    }

    try {
      setIsConfirmandoAssinatura(true);
      const payload = {
        email: String(emailAprovador).trim(),
        observacao: "",
      };

      await onPublicarFormulario?.(payload);

      setShowModalAssinatura(false);
      setEmailAprovador("");
    } catch (e) {
      console.error("[Ações] PUBLICAR :: erro ao publicar", e);
    } finally {
      setIsConfirmandoAssinatura(false);
      console.groupEnd();
    }
  };

  const handleSolicitarCorrecao = async () => {
    console.groupCollapsed("[Ações] SOLICITAR CORREÇÃO :: clique");
    try {
      setIsPreparandoCorrecao(true);

      const ok = await onPreSolicitarCorrecao?.();
      if (ok === false) {
        console.warn(
          "[Ações] SOLICITAR CORREÇÃO :: pré-salvamento falhou → abortar",
        );
        return;
      }

      await onSolicitarCorrecao?.();
    } catch (e) {
      console.error("[Ações] SOLICITAR CORREÇÃO :: erro", e);
    } finally {
      setIsPreparandoCorrecao(false);
      console.groupEnd();
    }
  };

  const acoesDesabilitadas =
    isSalvando ||
    isPreparandoCorrecao ||
    isAbrindoAssinatura ||
    isConfirmandoAssinatura ||
    isPublishing ||
    isSolicitandoCorrecao;

  return (
    <div className="acoes-formulario d-flex justify-content-end gap-3 mt-4">
      {showSalvar && (
        <button
          type="button"
          className="btn btn-salvar btn-acao d-flex align-items-center justify-content-center gap-2"
          onClick={handleSalvar}
          disabled={acoesDesabilitadas}
        >
          {isSalvando ? (
            <>
              <Spinner animation="border" size="sm" />
              ENVIANDO...
            </>
          ) : (
            "SALVAR"
          )}
        </button>
      )}

      {showSolicitarCorrecao && (
        <button
          type="button"
          className="btn btn-salvar btn-acao d-flex align-items-center justify-content-center gap-2"
          onClick={handleSolicitarCorrecao}
          disabled={acoesDesabilitadas}
        >
          {isSolicitandoCorrecao || isPreparandoCorrecao ? (
            <>
              <Spinner animation="border" size="sm" />
              ENVIANDO...
            </>
          ) : (
            "SOLICITAR CORREÇÃO"
          )}
        </button>
      )}

      {exibirSolicitarAssinatura && (
        <button
          type="button"
          className="btn btn-salvar btn-acao d-flex align-items-center justify-content-center gap-2"
          onClick={handleAbrirAssinatura}
          disabled={acoesDesabilitadas}
        >
          {isAbrindoAssinatura ? (
            <>
              <Spinner animation="border" size="sm" />
              ENVIANDO...
            </>
          ) : (
            "SOLICITAR ASSINATURA"
          )}
        </button>
      )}
      <Modal
        show={showModalAssinatura}
        onHide={() => setShowModalAssinatura(false)}
        centered
        size="lg"
        backdrop={isConfirmandoAssinatura ? "static" : true}
        keyboard={!isConfirmandoAssinatura}
      >
        <Modal.Header closeButton={!isConfirmandoAssinatura} />
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Favor informe o e-mail do aprovador</Form.Label>
              <Form.Control
                type="email"
                placeholder="Digite o e-mail"
                value={emailAprovador}
                onChange={(e) => {
                  setEmailAprovador(e.target.value);
                  setEmailValido(true);
                }}
                isInvalid={!emailValido}
                required
              />
              <Form.Control.Feedback type="invalid">
                Informe um e-mail válido.
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="flex-column text-center gap-3">
          <p className="mb-0">
            Deseja realmente solicitar a assinatura do formulário de despesas?
          </p>

          <div className="d-flex justify-content-center gap-3">
            <Button
              variant="secondary"
              onClick={() => setShowModalAssinatura(false)}
              disabled={acoesDesabilitadas}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirmarAssinatura}
              disabled={acoesDesabilitadas}
            >
              {isConfirmandoAssinatura ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  ENVIANDO...
                </>
              ) : (
                "Sim"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AcoesFormulario;
